import {isEqual, omit} from 'lodash';

import {isSelectAllJob} from '../../../helpers/jobHelpers';
import {JobModel} from '../../../models/api/jobModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {JobsActionsEnum} from './jobsActions';

export function jobsReducer(state: ResourceMap<JobModel>, action: AppAction): ResourceMap<JobModel> {
  switch (action.type) {
    case JobsActionsEnum.JOB_UPDATED: {
      const jobId = action.payload.id;
      return {
        ...state,
        [jobId]: mergeJob(state[jobId], action.payload),
      };
    }

    case JobsActionsEnum.JOB_DELETED:
      return omit(state, action.payload);

    default:
      return state;
  }
}

/*
 * Merger.
 */

function mergeJob(existingJob: JobModel | undefined, job: JobModel): JobModel {
  if (!existingJob) {
    return job;
  }

  // Preserve identity of patch for select all jobs.
  if (isSelectAllJob(existingJob) && isSelectAllJob(job) && isEqual(existingJob.patch, job.patch)) {
    return {
      ...job,
      patch: existingJob.patch,
    };
  }

  return job;
}
